// extracted by mini-css-extract-plugin
module.exports = {"event":"_2f1upBj_968VsRGYc1nBf0","event-text":"_3czLpQKqTJcdJAyI6VpMBy","widget":"_1WV2q5yEM2FRp0pYkThXw0"};